module.exports = __webpack_public_path__ + "img/25_69.18933831.png";